/* eslint react/prop-types: 0 */
import React, { useState, useEffect } from 'react';

import Card from '@mui/material/Card';

import CustomMapMarkerButton from '../../../components/1elements/Buttons/IconButtons/CustomMapMarkerButton';
import { CancelButton, Text } from '../../../components/1elements';
import SaveButton from '../../../components/1elements/Buttons/TextButtons/SaveButton';
import { useCustomMapMarker } from '../../../services/customMapMarker/useCustomMapMarker';
import MarkerListEditor from '../MarkerListEditor';
import MapMarkerPicker from '../MapMarkerPicker';

import './styles.scss';

const CustomMapMarker = ({ className }) => {
  const {
    isOpen,
    toggleIsOpen,
    selectedRow,
    setSelectedRow,
    handleSave,
    customizationMarkersOptions,
    setCustomizationMarkersOptions
  } = useCustomMapMarker();
  const [selectedMarker, setSelectedMarker] = useState(null);

  useEffect(() => {
    setSelectedMarker(customizationMarkersOptions[selectedRow]);
  }, [customizationMarkersOptions, selectedRow]);

  const updateMarker = (data) => {
    setCustomizationMarkersOptions((prev) => {
      const updatedData = Object.assign({}, prev[selectedRow], data);
      return {
        ...prev,
        [selectedRow]: {
          ...updatedData
        }
      };
    });
  };

  return (
    <Card
      className={`CustomMapMarker-card ${className} ${isOpen ? 'is-open' : ''}`}
    >
      <div className="CustomMapMarker-headerDiv">
        <CustomMapMarkerButton isOpen={isOpen} onClick={toggleIsOpen} />
        <Text type={'h1'} className="CustomMapMarker-header">
          Custom Map Marker
        </Text>
      </div>
      <Text className="CustomMapMarker-subHeader" type={'h7'}>
        Style Selection
      </Text>
      <div className="CustomMapMarker-mainDiv">
        <MarkerListEditor
          options={customizationMarkersOptions}
          selectedRow={selectedRow}
          setSelectedRow={setSelectedRow}
          onEditMode
          excludeKeys={[
            'industryTypeIcons',
            'entityTypeColors',
            'executiveEntityMarkers'
          ]}
        />
        {selectedMarker && (
          <MapMarkerPicker
            selectedMarker={selectedMarker}
            updateMarker={updateMarker}
            className="CustomMapMarker-editCard"
          />
        )}
      </div>
      <div className="CustomMapMarker-buttonDiv">
        <CancelButton onClick={toggleIsOpen} />
        <SaveButton onClick={handleSave} />
      </div>
    </Card>
  );
};

export default CustomMapMarker;
